export default "__VITE_ASSET__CjuJS1nB__"